var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('navbar'),_c('div',{staticClass:"header-home"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"left",on:{"click":() => _vm.handleHome()}},[_c('img',{attrs:{"src":_vm.settings.logo,"alt":_vm.settings.name,"title":_vm.settings.name}})]),_c('div',{staticClass:"right"},_vm._l((_vm.menu),function(item,i){return _c('a',{key:i,class:[
            'menu-item',
            0 == i ? 'menu-item-active' : ''
          ],on:{"click":() => _vm.handleMenuClick(item)}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }